module.exports = __webpack_public_path__ + "media/images/grid_preview_portrait-fbc93bf4c0fbf67569de8c0279b78db7.png";